import React from 'react';

const Hero = () => (
  <section className="hero">
    <div className="hero-content">
      <h1>AiLogify: The Ultimate Thinking Engine for Enterprises</h1>
      <p>Seamlessly integrates with leading enterprise learning platforms.</p>
      <a href="#demo" className="cta-button">Request a Demo</a>
    </div>
    <div className="partners">
      <h3>Trusted by:</h3>
      <div className="partner-logos">
        <span>Coursera for Business</span>
        <span>Udemy for Business</span>
        <span>LinkedIn Learning</span>
        <span>Pluralsight</span>
        <span>Skillsoft</span>
      </div>
    </div>
  </section>
);

export default Hero;